var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('span',{on:{"click":function($event){return _vm.$emit('joinWPSVip')}}},[_vm._v(_vm._s(`${_vm.type || 'WPS'}会员价限时全场特惠，可省￥${_vm.saved || 0}`))]),_c('img',{attrs:{"src":require("../../assets/images/signup-right.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }